module.exports = __webpack_public_path__ + "assets/img/text-footer-mail.svg";